export const PDF_HEADER = {
    pt: [
        {
            _id: 'patrolPoint',
            name: 'Ponto de ronda',
        },
        {
            _id: 'vigilant',
            name: 'Vigilante',
        },
        {
            _id: 'startDate',
            name: 'Data de início',
        },
        {
            _id: 'endDate',
            name: 'Data fim',
        },
        {
            _id: 'client',
            name: 'Cliente',
        },
        {
            _id: 'site',
            name: 'Local',
        },
    ],
    en: [
        {
            _id: 'patrolPoint',
            name: 'Patrol Point',
        },
        {
            _id: 'vigilant',
            name: 'Vigilant',
        },
        {
            _id: 'startDate',
            name: 'Start date',
        },
        {
            _id: 'endDate',
            name: 'End date',
        },
        {
            _id: 'client',
            name: 'Client',
        },
        {
            _id: 'site',
            name: 'Local',
        },
    ],
}
